import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { MemberApplicationTrainingHistory } from '@shared/models/data/MemberApplicationTrainingHistory';
import { UserProfileService } from './user-profile.service';

@Injectable({ providedIn: 'root' })
export class TrainingHistorySnapshotService {
  private snapshot = new BehaviorSubject<MemberApplicationTrainingHistory | null>(null);
  snapshot$ = this.snapshot.asObservable();

  constructor(private userProfileService: UserProfileService) {}

  /** Fetches training history once; subsequent calls are no-ops. */
  load(): void {
    if (this.snapshot.getValue() !== null) return;
    this.userProfileService.getTrainingData().pipe(
      catchError(err => {
        console.warn('TrainingHistorySnapshotService: failed to load training history', err);
        return of({} as MemberApplicationTrainingHistory);
      })
    ).subscribe(data => {
      console.log('TrainingHistorySnapshotService: snapshot loaded', data);
      this.snapshot.next(data ?? {} as MemberApplicationTrainingHistory);
    });
  }

  getSnapshot(): MemberApplicationTrainingHistory | null {
    return this.snapshot.getValue();
  }
}
